import { Link } from "react-router-dom";
import LiveCall from "../../modules/voice/calls/models/LiveCall";
import Avatar from "../base/Avatar";
import Icon from "../base/Icon";
import { createJob, demoPhone, demoText, isDemo, openJobQuickView, setCallToListen, setChanSpyLine, setHangupChannel, useJobs } from "../../core/Global";
import Timer from "../timer/Timer";
import { CallTypes } from "../../core/Enums";
import { useEffect, useState } from "react";
import FlexRow from "../base/FlexRow";


interface IProps {
    call: LiveCall
    agentView?: boolean
}

export default function LiveCallItem(props: IProps) {

    const jobs = useJobs()



    return (
        <div className="card mb-2"
            onClick={e => {
                e.preventDefault();
            }}>

            <div className="card-header d-flex align-items-center p-3" style={{ minHeight: 0 }}>
                <FlexRow className="text-dark">

                    {
                        props.call.callType == CallTypes.Incoming &&
                        <Icon icon='phone-arrow-down-left' type='solid' className="text-success opacity-75 me-4" size={18} title="Incoming Call" />
                    }

                    {
                        props.call.callType == CallTypes.Outgoing &&
                        <Icon icon='phone-arrow-up-right' type='solid' className="text-primary opacity-75 me-4" size={18} title="Outgoing Call" />
                    }

                    <Avatar width={16} avatarUrl={(props.call.sourceAgent?.country ? props.call.sourceAgent?.country?.flagSquare : props.call.sourceAgent?.avatarUrl)} className="me-1" />
                    {
                        props.call.sourceAgent?.id ?
                            <div className='me-1 fw-bold fs-8 limited-text mw-100px' title={props.call.sourceAgent.name}>
                                {isDemo() ? "Agent " + demoText(props.call.sourceAgent.name) : props.call.sourceAgent.name}
                            </div>
                            :
                            <div className='me-1 fw-bold fs-8 limited-text mw-100px' title={props.call.sourceAgent?.number}>
                                {isDemo() ? demoPhone() : props.call.sourceAgent?.number}
                            </div>
                    }

                    {
                        props.call.sourceAgent?.id ?
                            <div className='me-1 fs-9'>
                                ({props.call.sourceAgent?.number})
                            </div>
                            : !props.call.sourceAgent?.country ?
                                <div className='me-1 fs-9 limited-text mw-150px'>
                                    ({props.call.sourceAgent?.name})
                                </div>
                                : <></>
                    }
                </FlexRow>
                <div className="d-flex align-items-center ms-auto">
                    {
                        props.agentView ?
                            <button type="button" className={"d-flex align-items-center btn btn-" + (props.call.talking ? "danger" : "primary") + " btn-agent-ext"}>
                                {
                                    props.call.talking ?
                                        <Icon icon='phone-volume' type='solid' color="white" className="me-1 fs-8" />
                                        :
                                        <Icon id={"icon-ring-" + props.call.id} icon='phone-rotary' shake type='solid' color="white" className="me-1 fs-8" />
                                }
                                <span className="me-3">{props.call.extNumber}</span>
                                {
                                    props.call.talking ?
                                        <Timer totalSeconds={props.call.talkingSeconds} width={50} />
                                        :
                                        <Timer totalSeconds={props.call.ringingSeconds} width={50} />
                                }

                            </button>
                            :
                            <div className="btn-group" role="group">
                                <button className={"d-flex align-items-center btn btn-" + (props.call.talking ? "danger" : "primary") + " btn-agent-ext"}
                                    onClick={e => {
                                        e.preventDefault();
                                        //var li = window.DialByLine('audio', undefined, '551' + props.call.extNumber);
                                        //setChanSpyLine(li);
                                        setCallToListen(props.call);
                                    }}>
                                    {
                                        props.call.talking ?
                                            <Icon icon='phone-volume' type='solid' color="white" className="me-2 fs-8" />
                                            :
                                            <Icon id={"icon-ring-" + props.call.id} icon='phone-rotary' shake type='solid' color="white" className="me-2 fs-8" />
                                    }
                                    {
                                        props.call.talking ?
                                            <Timer totalSeconds={props.call.talkingSeconds} width={35} />
                                            :
                                            <Timer totalSeconds={props.call.ringingSeconds} width={35} />
                                    }

                                </button>
                                <div className="btn-group" role="group">
                                    <button id={"btn-menu-" + props.call.id} type="button" className={"btn btn-" + (props.call.talking ? "danger" : "primary") + " btn-agent-ext dropdown-toggle dsp-dropdown"} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                        onClick={e => {
                                            window.dropdown("btn-menu-" + props.call.id);
                                        }}>
                                        <Icon icon="ellipsis-vertical" className="dsp-dropdown" size={10} />
                                    </button>
                                    <div className="dropdown-menu dsp-dropdown">
                                        <Link className="dropdown-item dsp-dropdown fs-8" to={"/voice/call/" + props.call.id}>
                                            <Icon icon="phone" className="dsp-dropdown w-20px text-center" size={10} />
                                            Call Details
                                        </Link>
                                        <a className="dropdown-item dsp-dropdown fs-8" href="#"
                                            onClick={e => {
                                                e.preventDefault();
                                                var li = window.DialByLine('audio', undefined, '551' + props.call.extNumber);
                                                setChanSpyLine(li);
                                                setCallToListen(props.call);
                                                window.dropdown("btn-menu-" + props.call.id, true);
                                            }}>
                                            <Icon icon="volume" className="dsp-dropdown w-20px text-center" size={10} />
                                            Listen To Call
                                        </a>
                                        <a className="dropdown-item dsp-dropdown text-danger fs-8" href="#"
                                            onClick={e => {
                                                e.preventDefault();
                                                setHangupChannel(props.call.id);
                                                window.openModal("modal-hangup");
                                            }}>
                                            <Icon icon="phone-slash" className="dsp-dropdown w-20px text-danger text-center" size={10} />
                                            Hang Up
                                        </a>
                                    </div>
                                </div>
                            </div>
                    }


                </div>
            </div>

            {
                props.agentView ?
                    <div className={"card-body p-3 position-relative"}>

                        <FlexRow className="d-flex align-items-center mt-2">

                            {
                                props.call.callType == CallTypes.Incoming &&
                                <>
                                    {
                                        props.call.queueName &&
                                        <>
                                            <Icon icon="arrow-right-to-line" size={12} className="me-1" />
                                            <div className='fs-9 limited-text mw-75px me-5' style={{ marginTop: 2 }}>
                                                {isDemo() ? "Queue " + demoText(props.call.queueName) : props.call.queueName}
                                            </div>
                                        </>
                                    }

                                    {
                                        props.call.jobSource &&
                                        <>
                                            <Icon icon="bullhorn" size={12} className="me-1" />
                                            <div className='fs-9 limited-text mw-100px' style={{ marginTop: 2 }}>
                                                {isDemo() ? "Source " + demoText(props.call.jobSource.name) : props.call.jobSource.name}
                                            </div>
                                        </>
                                    }
                                </>
                            }


                        </FlexRow>


                        {
                            jobs &&
                            <>
                                {
                                    jobs.filter(j => j.phoneRaw == props.call.phoneNumber)
                                        .map(job =>
                                            <div key={`call-current-job-${job.id}`} className="bg-light-primary cursor-pointer my-2 p-2"
                                                onClick={e => {
                                                    openJobQuickView(job.id)
                                                }}>

                                                <FlexRow className="mb-2">
                                                    <FlexRow>
                                                        <Icon icon="circle" type="solid" color={job.jobStatus?.color} size={12} />
                                                        <span className={`fs-8 ms-1`} style={{ width: 45 }}>
                                                            <Timer key={`job-timer-${job.id}`} baseDate={job.lastStatusUpdatedAt} short />
                                                        </span>
                                                    </FlexRow>
                                                    <div className="fs-8 me-5">
                                                        #{job.jobId}
                                                    </div>
                                                    <FlexRow className="fs-8 me-5">
                                                        <Icon icon="wrench-simple" type="solid" size={10} className="me-1" />
                                                        <span>{job.jobType}</span>
                                                    </FlexRow>

                                                    {
                                                        job.tech &&
                                                        <FlexRow className="fs-8 me-5">
                                                            <Icon icon="user-helmet-safety" type="solid" size={10} className="me-1" />
                                                            <span>{job.tech?.fullName}</span>
                                                        </FlexRow>
                                                    }
                                                </FlexRow>

                                                <FlexRow className="fs-8">
                                                    <Icon icon="location-dot" type="solid" size={10} className="me-1" />
                                                    <span>{job.address?.title}</span>
                                                </FlexRow>

                                            </div>
                                        )
                                }
                            </>
                        }


                    </div>
                    :
                    <div className={"card-body p-3 position-relative"}>

                        <FlexRow>

                            {
                                props.call.callType == CallTypes.Incoming &&
                                <div>
                                    <FlexRow>
                                        <Icon icon="phone-office" size={12} className="me-1" />
                                        <div className='fs-9' style={{ marginTop: 1 }}>
                                            {props.call.extNumber}
                                        </div>
                                        <Avatar width={15} avatarUrl={props.call.destinationAgent?.avatarUrl} className="ms-5 me-1" />
                                        <div className='fs-9 limited-text mw-100px' style={{ marginTop: 2 }}>
                                            {isDemo() ? "Agent " + demoText(props.call.destinationAgent?.name) : props.call.destinationAgent?.name}
                                        </div>
                                    </FlexRow>
                                    <FlexRow className="d-flex align-items-center mt-2">
                                        {/* <Icon icon="briefcase" size={12} className="me-1" />
                        <div className='fs-9 limited-text mw-75px' style={{ marginTop: 2 }}>
                            {isDemo() ? "Company " + demoText(props.call.companyName) : props.call.companyName}
                        </div> */}

                                        {
                                            props.call.queueName &&
                                            <>
                                                <Icon icon="arrow-right-to-line" size={12} className="me-1" />
                                                <div className='fs-9 limited-text mw-75px' style={{ marginTop: 2 }}>
                                                    {isDemo() ? "Queue " + demoText(props.call.queueName) : props.call.queueName}
                                                </div>
                                            </>
                                        }

                                        {
                                            props.call.jobSource &&
                                            <>
                                                <Icon icon="bullhorn" size={12} className="ms-5 me-1" />
                                                <div className='fs-9 limited-text mw-100px' style={{ marginTop: 2 }}>
                                                    {isDemo() ? "Source " + demoText(props.call.jobSource.name) : props.call.jobSource.name}
                                                </div>
                                            </>
                                        }
                                    </FlexRow>
                                </div>
                            }

                            {
                                props.call.callType == CallTypes.Outgoing &&
                                <>
                                    <FlexRow>
                                        {
                                            props.call.destinationAgent?.country ?
                                                <Avatar width={15} avatarUrl={props.call.destinationAgent?.country.flagSquare} className="me-1" />
                                                :
                                                <Icon icon="phone-office" size={12} className="me-1" />
                                        }

                                        <div className='fs-9' style={{ marginTop: 1 }}>
                                            {isDemo() ? demoPhone() : props.call.destinationAgent?.number}
                                        </div>

                                        {
                                            props.call.jobSource &&
                                            <>
                                                <Icon icon="bullhorn" size={12} className="ms-5 me-1" />
                                                <div className='fs-9 limited-text mw-100px' style={{ marginTop: 2 }}>
                                                    {isDemo() ? "Source " + demoText(props.call.jobSource.name) : props.call.jobSource.name}
                                                </div>
                                            </>
                                        }

                                    </FlexRow>
                                </>
                            }



                        </FlexRow>




                    </div>
            }



        </div>
    )
}